import { StyledInput } from './Input.styled';

const Input = ({ Component, label, htmlFor, children, ...props }) => {
  const getAddonBefore = () => {
    if (label) {
      return <label htmlFor={htmlFor}>{label}</label>;
    }
  };

  return (
    <StyledInput as={Component} addonBefore={getAddonBefore()} {...props}>
      {children}
    </StyledInput>
  );
};

export default Input;
